export enum PopoverAttachmentType {
    FULL = 'full',
    VERTICAL = 'vertical',
    HORIZONTAL = 'horizontal'
}

export enum PopoverHeightRestriction {
    NONE                = 'none',
    WINDOW_HEIGHT       = 'window-height',
    HALF_WINDOW_HEIGHT  = 'half-window-height'
}

// export enum PopoverTargetAttachment {
//     BOTTOM_LEFT = "bottom left",
// }



// arrow distance from the popover's attached edge in the legacy CSS (arrows-version-1/2.scss) - pass as
// Popover.arrowEdgeInset to keep a popover's arrow where it was before JS alignment
export enum PopoverArrowEdgeInset {
    ARROWS_V1   = 20,
    ARROWS_V2   = 26,
}
